module.exports = __webpack_public_path__ + "media/in_destinum/img/barcelona-tour-73aa273e887aa3a9dd03ec97e7e63296.jpg";